import React from "react";
import {
  AccountBalanceOutlined,
  AccountBalanceWalletOutlined,
  BusinessOutlined,
  DescriptionOutlined,
  DomainOutlined,
  ModeStandbyRounded,
  PaymentOutlined,
  PersonOutlined,
  StoreOutlined,
  ToggleOnOutlined,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";
import { usePrepaymentDetailContext } from "contexts/PrepaymentDetailContext";
import OpenInNewTab from "components/Shared/OpenInNewTab";
import { useAuth } from "hooks";

const PrepaymentBasicDetail = () => {
  const { isVendor } = useAuth();
  const { prepaymentDetail, loadingPrepayment } = usePrepaymentDetailContext();

  return !loadingPrepayment ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <PaymentOutlined color="primary" />}
            title="Prepayment ID"
            subtitle={prepaymentDetail?.prepaymentID || "N/A"}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccountBalanceOutlined color="primary" />}
            title="Account"
            subtitle={prepaymentDetail?.account?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <DomainOutlined color="primary" />}
            title="Entity"
            subtitle={prepaymentDetail?.entity?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <DomainOutlined color="primary" />}
            title="Added By"
            subtitle={
              prepaymentDetail?.addedBy?._id ? (
                isVendor ? (
                  <span>{prepaymentDetail.addedBy.name}</span>
                ) : (
                  <OpenInNewTab
                    label={prepaymentDetail.addedBy.name}
                    link={`/app/crm/user/${prepaymentDetail.addedBy._id}/detail`}
                    disableIcon
                  />
                )
              ) : (
                "N/A"
              )
            }
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            title="Linked Type"
            icon={() => <ModeStandbyRounded color="primary" />}
            subtitle={
              prepaymentDetail?.sourceModel === "VendorProfile"
                ? "Vendor Profile"
                : prepaymentDetail?.sourceModel === "Customer"
                  ? "Customer Profile"
                  : prepaymentDetail?.sourceModel === "Contractor"
                    ? "Contractor Profile"
                    : "Unknown Profile"
            }
          />
        </Grid>

        {prepaymentDetail?.sourceModel === "VendorProfile" ? (
          <>
            <Grid item xs={4}>
              <InformationTile
                icon={() => <PersonOutlined color="primary" />}
                title="Owner Name"
                subtitle={prepaymentDetail?.sourceModelRef?.ownerName || "N/A"}
              />
            </Grid>
            <Grid item xs={4}>
              <InformationTile
                icon={() => <StoreOutlined color="primary" />}
                title="Shop Name"
                subtitle={prepaymentDetail?.sourceModelRef?.shopName || "N/A"}
              />
            </Grid>
          </>
        ) : prepaymentDetail?.sourceModel === "Customer" ? (
          <Grid item xs={4}>
            <InformationTile
              icon={() => <PersonOutlined color="primary" />}
              title="Customer Name"
              subtitle={prepaymentDetail?.sourceModelRef?.customerName || "N/A"}
            />
          </Grid>
        ) : null}

        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccountBalanceWalletOutlined color="primary" />}
            title="Type"
            subtitle={prepaymentDetail?.type || "N/A"}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccountBalanceWalletOutlined color="primary" />}
            title="Payment Method"
            subtitle={
              prepaymentDetail?.collectionMethod?.name
                ? prepaymentDetail.collectionMethod.name
                : "N/A"
            }
          />
        </Grid>

        {prepaymentDetail?.bankName?.name && (
          <Grid item xs={4}>
            <InformationTile
              icon={() => <BusinessOutlined color="primary" />}
              title="Bank Name"
              subtitle={prepaymentDetail?.bankName?.name || "N/A"}
            />
          </Grid>
        )}

        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccountBalanceWalletOutlined color="primary" />}
            title="Amount"
            subtitle={
              prepaymentDetail?.amount
                ? prepaymentDetail.amount.toFixed(2)
                : "N/A"
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <AccountBalanceWalletOutlined color="primary" />}
            title="Balance Amount"
            subtitle={
              prepaymentDetail?.balanceAmount
                ? prepaymentDetail.balanceAmount.toFixed(2)
                : "0"
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <DescriptionOutlined color="primary" />}
            title="Description"
            subtitle={prepaymentDetail?.description || "N/A"}
            multi
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <ToggleOnOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={prepaymentDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default PrepaymentBasicDetail;
